<div class="p-3 rounded-3">
    <div class="row mb-2">
        <div class="col-12 mb-3">
            <div class="titletoptables d-flex justify-content-between align-items-center w-100">
                <div class="d-flex align-items-center">
                    <div class="leftsideicons">
                        <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="var(--brand-600)"
                            stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
                            <path d="M3 12a9 9 0 0 1 18 0"></path>
                            <path d="M21 12v5a2 2 0 0 1-2 2h-1"></path>
                            <rect x="17" y="12" width="4" height="6" rx="1.5"></rect>
                            <rect x="3" y="12" width="4" height="6" rx="1.5"></rect>
                        </svg>
                    </div>
                    <h3 class="mb-0">
                        {{ "Support Tickets" }}
                    </h3>
                </div>
                <button type="button" class="btn btn-primary addBtn" (click)="openAddTicketDialog()">Add Ticket</button>
            </div>
        </div>
    </div>
    <div class="grid-card">
        <div class="filters-bar">
            <div class="filter-search">
                <app-search-input [value]="searchString" (valueChange)="filterBySearch($event)" (cleared)="clearSearch()"></app-search-input>
            </div>
            <div style="display: flex; flex-direction: column;">
                <span class="dp-label">Status</span>
                <mat-form-field class="filter-select" appearance="fill" style="width: 160px;">
                    <mat-select [value]="selectedStatus" (selectionChange)="onStatusFilterChange($event.value)">
                        <mat-option *ngFor="let opt of statusOptions" [value]="opt.Id">{{ opt.Name }}</mat-option>
                    </mat-select>
                </mat-form-field>
            </div>
            <div style="display: flex; flex-direction: column;">
                <span class="dp-label">Priority</span>
                <mat-form-field class="filter-select" appearance="fill" style="width: 160px;">
                    <mat-select [value]="selectedPriority" (selectionChange)="onPriorityFilterChange($event.value)">
                        <mat-option *ngFor="let opt of priorityOptions" [value]="opt.Id">{{ opt.Name }}</mat-option>
                    </mat-select>
                </mat-form-field>
            </div>
        </div>
        <app-data-grid>
        <kendo-grid #grid [loading]="kendoLoading" [data]="gridData" [filter]="state.filter"
            [sortable]="{mode: 'single'}" [columnMenu]="{ filter: true }" [pageSize]="state.take" [skip]="state.skip"
            [pageable]="gridData?.data?.length && gridData.data.length > 0 ? pageableWithAll : false"
            [sort]="state.sort" [resizable]="true" [reorderable]="true" filterable="menu" [selectable]="true"
            (dataStateChange)="gridData ? dataStateChange($event): null" [groupable]="true" [group]="state.group"
            [navigable]="true" [height]="gridHeight">
            <kendo-grid-column field="Action" [width]="40" title=" " [includeInChooser]="false" [sortable]="false"
                [filterable]="false" [columnMenu]="false" [groupable]="false" headerClass="col-action" class="col-action">
                <ng-template kendoGridCellTemplate let-dataItem>
                    <div class="text-center">
                        <div class="mx-2 d-inline-block">
                            <button class="verical_menu" type="button" id="dropdownMenuButton1"
                                data-bs-toggle="dropdown" aria-expanded="false">
                                <svg class="vertical" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
                                    <circle cx="12" cy="5" r="2"></circle>
                                    <circle cx="12" cy="12" r="2"></circle>
                                    <circle cx="12" cy="19" r="2"></circle>
                                </svg>
                            </button>
                            <ul class="dropdown-menu grid-action-menu" aria-labelledby="dropdownMenuButton1">
                                <li class="cursor-pointer">
                                    <a class="dropdown-item" (click)="openViewDialog(dataItem)">
                                        <kendo-svg-icon [icon]="icons.view"></kendo-svg-icon> View</a>
                                </li>
                                <li class="cursor-pointer">
                                    <a class="dropdown-item" (click)="openHistoryDialog(dataItem)">
                                        <kendo-svg-icon [icon]="icons.history"></kendo-svg-icon> View History</a>
                                </li>
                                <li class="cursor-pointer" *ngIf="canAssign(dataItem)">
                                    <a class="dropdown-item" (click)="openAssignDialog(dataItem)">
                                        <kendo-svg-icon [icon]="icons.assign"></kendo-svg-icon>
                                        {{ dataItem.AssignedToUserId ? 'Reassign' : 'Assign' }}</a>
                                </li>
                                <li class="cursor-pointer" *ngIf="canUpdateStatus(dataItem)">
                                    <a class="dropdown-item" (click)="openUpdateStatusDialog(dataItem)">
                                        <kendo-svg-icon [icon]="icons.updateStatus"></kendo-svg-icon> Update Status</a>
                                </li>
                                <li class="cursor-pointer" *ngIf="canResolve(dataItem)">
                                    <a class="dropdown-item" (click)="openResolveDialog(dataItem)">
                                        <kendo-svg-icon [icon]="icons.resolve"></kendo-svg-icon> Resolve</a>
                                </li>
                                <li class="cursor-pointer" *ngIf="canClose(dataItem)">
                                    <a class="dropdown-item" (click)="openCloseDialog(dataItem)">
                                        <kendo-svg-icon [icon]="icons.close"></kendo-svg-icon> Close</a>
                                </li>
                                <li class="cursor-pointer" *ngIf="canReopen(dataItem)">
                                    <a class="dropdown-item" (click)="openReopenDialog(dataItem)">
                                        <kendo-svg-icon [icon]="icons.reopen"></kendo-svg-icon> Reopen</a>
                                </li>
                            </ul>
                        </div>
                    </div>
                </ng-template>
            </kendo-grid-column>
            <kendo-grid-column field="TicketNumber" [width]="130" title="Ticket #">
            </kendo-grid-column>
            <kendo-grid-column field="Subject" [width]="220" title="Subject">
            </kendo-grid-column>
            <kendo-grid-column field="Priority" [width]="110" title="Priority">
                <ng-template kendoGridCellTemplate let-dataItem>
                    <span [class]="'badge ' + getPriorityBadgeClass(dataItem.Priority)">{{ dataItem.PriorityName }}</span>
                </ng-template>
                <ng-template kendoGridGroupHeaderTemplate let-value="value">
                    Priority: {{ optionName(priorityOptions, value) }}
                </ng-template>
                <ng-template kendoGridFilterMenuTemplate let-filter let-column="column" let-filterService="filterService">
                    <ul class="k-radio-list k-reset">
                        <li *ngFor="let option of priorityFilterOptions">
                            <kendo-radiobutton #priorityRadio name="ticket-priority-filter"
                                [checked]="optionFilterValue(filter, column.field) === option.Id"
                                (change)="filterByOption(filterService, column.field, option.Id)"></kendo-radiobutton>
                            <label class="k-radio-label" [attr.for]="priorityRadio.focusableId">{{ option.Name }}</label>
                        </li>
                    </ul>
                </ng-template>
            </kendo-grid-column>
            <kendo-grid-column field="Status" [width]="120" title="Status">
                <ng-template kendoGridCellTemplate let-dataItem>
                    <span [class]="'badge ' + getStatusBadgeClass(dataItem.Status)">{{ dataItem.StatusName }}</span>
                </ng-template>
                <ng-template kendoGridGroupHeaderTemplate let-value="value">
                    Status: {{ optionName(statusOptions, value) }}
                </ng-template>
                <ng-template kendoGridFilterMenuTemplate let-filter let-column="column" let-filterService="filterService">
                    <ul class="k-radio-list k-reset">
                        <li *ngFor="let option of statusFilterOptions">
                            <kendo-radiobutton #statusRadio name="ticket-status-filter"
                                [checked]="optionFilterValue(filter, column.field) === option.Id"
                                (change)="filterByOption(filterService, column.field, option.Id)"></kendo-radiobutton>
                            <label class="k-radio-label" [attr.for]="statusRadio.focusableId">{{ option.Name }}</label>
                        </li>
                    </ul>
                </ng-template>
            </kendo-grid-column>
            <kendo-grid-column field="CompanyName" [width]="170" title="Clinic">
                <ng-template kendoGridCellTemplate let-dataItem>
                    {{ dataItem.CompanyName ?? '—' }}
                </ng-template>
            </kendo-grid-column>
            <kendo-grid-column field="RaisedByUserName" [width]="150" title="Raised By">
            </kendo-grid-column>
            <kendo-grid-column field="AssignedToUserName" [width]="150" title="Assigned To">
                <ng-template kendoGridCellTemplate let-dataItem>
                    {{ dataItem.AssignedToUserName ?? 'Unassigned' }}
                </ng-template>
                <ng-template kendoGridGroupHeaderTemplate let-value="value">
                    Assigned To: {{ value ?? 'Unassigned' }}
                </ng-template>
            </kendo-grid-column>
            <kendo-grid-column field="CreatedOn" [width]="150" title="Created" filter="date" format="dd/MM/yyyy">
                <ng-template kendoGridCellTemplate let-dataItem>
                    {{ dataItem.CreatedOn | date:'medium' }}
                </ng-template>
                <ng-template kendoGridGroupHeaderTemplate let-value="value">
                    Created: {{ value | date:'medium' }}
                </ng-template>
            </kendo-grid-column>
            <kendo-grid-column field="ModifiedOn" [width]="150" title="Updated" filter="date" format="dd/MM/yyyy">
                <ng-template kendoGridCellTemplate let-dataItem>
                    {{ dataItem.ModifiedOn ? (dataItem.ModifiedOn | date:'medium') : '—' }}
                </ng-template>
                <ng-template kendoGridGroupHeaderTemplate let-value="value">
                    Updated: {{ value ? (value | date:'medium') : '—' }}
                </ng-template>
            </kendo-grid-column>
        </kendo-grid>
        </app-data-grid>
    </div>
</div>

<ng-template #viewTicketDialog>
    <div class="modal-dialog">
        <div class="modal-content">
            <div class="modal-header">
                <h4 class="popup-title">Ticket {{ selectedTicket?.TicketNumber }}</h4>
                <button type="button" class="btn-close" aria-label="Close" (click)="closeDialog()"></button>
            </div>
            <div class="modal-body">
                <mat-dialog-content>
                    <div class="row">
                        <div class="col-md-6 py-2">
                            <label class="app-field-label">Subject</label>
                            <div>{{ selectedTicket?.Subject }}</div>
                        </div>
                        <div class="col-md-3 py-2">
                            <label class="app-field-label">Priority</label>
                            <div><span [class]="'badge ' + getPriorityBadgeClass(selectedTicket?.Priority ?? 0)">{{ selectedTicket?.PriorityName }}</span></div>
                        </div>
                        <div class="col-md-3 py-2">
                            <label class="app-field-label">Status</label>
                            <div><span [class]="'badge ' + getStatusBadgeClass(selectedTicket?.Status ?? 0)">{{ selectedTicket?.StatusName }}</span></div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-12 py-2">
                            <label class="app-field-label">Description</label>
                            <div class="ticket-readonly-block">{{ selectedTicket?.Description }}</div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-4 py-2">
                            <label class="app-field-label">Clinic</label>
                            <div>{{ selectedTicket?.CompanyName ?? '—' }}</div>
                        </div>
                        <div class="col-md-4 py-2">
                            <label class="app-field-label">Raised By</label>
                            <div>{{ selectedTicket?.RaisedByUserName }}</div>
                            <div class="text-muted ticket-subtext">{{ selectedTicket?.RaisedByEmail }}</div>
                        </div>
                        <div class="col-md-4 py-2">
                            <label class="app-field-label">Assigned To</label>
                            <div>{{ selectedTicket?.AssignedToUserName ?? 'Unassigned' }}</div>
                        </div>
                    </div>
                    <div class="row" *ngIf="selectedTicket?.ResolutionNotes">
                        <div class="col-12 py-2">
                            <label class="app-field-label">Resolution Notes</label>
                            <div class="ticket-readonly-block">{{ selectedTicket?.ResolutionNotes }}</div>
                        </div>
                    </div>
                    <div class="row" *ngIf="getAttachmentUrls(selectedTicket).length > 0">
                        <div class="col-12 py-2">
                            <label class="app-field-label">Attachments</label>
                            <div class="d-flex flex-wrap ticket-attachments">
                                <a *ngFor="let url of getAttachmentUrls(selectedTicket)" [href]="url" target="_blank"
                                    rel="noopener noreferrer" class="ticket-attachment-thumb">
                                    <img [src]="url" alt="Ticket attachment" />
                                </a>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-3 py-2">
                            <label class="app-field-label">Created</label>
                            <div>{{ selectedTicket?.CreatedOn | date:'medium' }}</div>
                        </div>
                        <div class="col-md-3 py-2">
                            <label class="app-field-label">Updated</label>
                            <div>{{ selectedTicket?.ModifiedOn ? (selectedTicket?.ModifiedOn | date:'medium') : '—' }}</div>
                        </div>
                        <div class="col-md-3 py-2">
                            <label class="app-field-label">Resolved</label>
                            <div>{{ selectedTicket?.ResolvedOn ? (selectedTicket?.ResolvedOn | date:'medium') : '—' }}</div>
                        </div>
                        <div class="col-md-3 py-2">
                            <label class="app-field-label">Closed</label>
                            <div>{{ selectedTicket?.ClosedOn ? (selectedTicket?.ClosedOn | date:'medium') : '—' }}</div>
                        </div>
                    </div>
                </mat-dialog-content>
                <mat-dialog-actions align="end">
                    <button mat-raised-button type="button" class="btn btn-secondary" (click)="closeDialog()">Close</button>
                </mat-dialog-actions>
            </div>
        </div>
    </div>
</ng-template>

<ng-template #historyDialog>
    <div class="modal-dialog modal-lg">
        <div class="modal-content">
            <div class="modal-header">
                <h4 class="popup-title">Ticket History — {{ selectedTicket?.TicketNumber }}</h4>
                <button type="button" class="btn-close" aria-label="Close" (click)="closeDialog()"></button>
            </div>
            <div class="modal-body">
                <mat-dialog-content>
                    <app-data-grid>
                    <kendo-grid [loading]="historyLoading" [kendoGridBinding]="historyData" [groupable]="true" [resizable]="true" [reorderable]="true">
                        <kendo-grid-column field="ActionName" title="Action" [width]="130">
                        </kendo-grid-column>
                        <kendo-grid-column title="Status Change" [width]="180" [groupable]="false">
                            <ng-template kendoGridCellTemplate let-dataItem>
                                <span *ngIf="dataItem.FromStatusName || dataItem.ToStatusName">
                                    {{ dataItem.FromStatusName ?? '—' }} &rarr; {{ dataItem.ToStatusName ?? '—' }}
                                </span>
                            </ng-template>
                        </kendo-grid-column>
                        <kendo-grid-column field="ToAssignedToUserName" title="Assigned To" [width]="160">
                            <ng-template kendoGridCellTemplate let-dataItem>
                                {{ dataItem.ToAssignedToUserName ?? '—' }}
                            </ng-template>
                        </kendo-grid-column>
                        <kendo-grid-column title="Notes" [width]="220" [groupable]="false">
                            <ng-template kendoGridCellTemplate let-dataItem>
                                {{ dataItem.ResolutionNotes ?? dataItem.Remarks ?? '' }}
                            </ng-template>
                        </kendo-grid-column>
                        <kendo-grid-column field="ActionByName" title="By" [width]="170">
                            <ng-template kendoGridCellTemplate let-dataItem>
                                {{ dataItem.ActionByName }} <span class="text-muted">({{ dataItem.ActionByRole }})</span>
                            </ng-template>
                        </kendo-grid-column>
                        <kendo-grid-column field="ActionOn" title="When" [width]="160">
                            <ng-template kendoGridCellTemplate let-dataItem>
                                {{ dataItem.ActionOn | date:'medium' }}
                            </ng-template>
                            <ng-template kendoGridGroupHeaderTemplate let-value="value">
                                When: {{ value | date:'medium' }}
                            </ng-template>
                        </kendo-grid-column>
                    </kendo-grid>
                    </app-data-grid>
                </mat-dialog-content>
                <mat-dialog-actions align="end">
                    <button mat-raised-button type="button" class="btn btn-secondary" (click)="closeDialog()">Close</button>
                </mat-dialog-actions>
            </div>
        </div>
    </div>
</ng-template>

<ng-template #assignDialog>
    <div class="modal-dialog">
        <div class="modal-content">
            <div class="modal-header">
                <h4 class="popup-title">{{ selectedTicket?.AssignedToUserId ? 'Reassign' : 'Assign' }} Ticket {{ selectedTicket?.TicketNumber }}</h4>
                <button type="button" class="btn-close" aria-label="Close" (click)="closeDialog()"></button>
            </div>
            <form class="diagSave" [formGroup]="assignForm" (ngSubmit)="submitAssign()" autocomplete="off">
                <div class="modal-body">
                    <mat-dialog-content>
                        <div *ngIf="actionError" class="ticket-action-error" role="alert">{{ actionError }}</div>
                        <div class="row">
                            <div class="col-12">
                                <div class="form-group">
                                    <label class="app-field-label">Assign To<span class="app-field-required">*</span></label>
                                    <mat-form-field class="w-100">
                                        <mat-select formControlName="AssignedToUserId" placeholder="Select a team member"
                                            [panelClass]="'custom-select-panel'" [disableOptionCentering]="true" required>
                                            <mat-option *ngFor="let agent of assignableAgents" [value]="agent.Id">{{ agent.fullname }}</mat-option>
                                        </mat-select>
                                        <mat-error *ngIf="assignForm.get('AssignedToUserId')?.errors?.['required']">
                                            Please select a team member
                                        </mat-error>
                                    </mat-form-field>
                                </div>
                            </div>
                        </div>
                    </mat-dialog-content>
                </div>
                <mat-dialog-actions align="end">
                    <button mat-raised-button type="button" class="btn btn-secondary" style="margin-right: 10px;"
                        [disabled]="actionSaving" (click)="closeDialog()">Cancel</button>
                    <button mat-raised-button type="submit" class="btn btn-primary" [disabled]="actionSaving">
                        <span *ngIf="actionSaving" class="spinner-border spinner-border-sm me-1"></span>
                        {{ actionSaving ? 'Saving…' : 'Save' }}
                    </button>
                </mat-dialog-actions>
            </form>
        </div>
    </div>
</ng-template>

<ng-template #updateStatusDialog>
    <div class="modal-dialog">
        <div class="modal-content">
            <div class="modal-header">
                <h4 class="popup-title">Update Status — {{ selectedTicket?.TicketNumber }}</h4>
                <button type="button" class="btn-close" aria-label="Close" (click)="closeDialog()"></button>
            </div>
            <form class="diagSave" [formGroup]="statusForm" (ngSubmit)="submitUpdateStatus()" autocomplete="off">
                <div class="modal-body">
                    <mat-dialog-content>
                        <div *ngIf="actionError" class="ticket-action-error" role="alert">{{ actionError }}</div>
                        <div class="row">
                            <div class="col-12">
                                <div class="form-group">
                                    <label class="app-field-label">New Status<span class="app-field-required">*</span></label>
                                    <mat-form-field class="w-100">
                                        <mat-select formControlName="Status" placeholder="Select new status"
                                            [panelClass]="'custom-select-panel'" [disableOptionCentering]="true"
                                            (selectionChange)="onStatusChoiceChange($event.value)" required>
                                            <mat-option *ngFor="let opt of updateStatusOptions" [value]="opt.value">{{ opt.label }}</mat-option>
                                        </mat-select>
                                        <mat-error *ngIf="statusForm.get('Status')?.errors?.['required']">
                                            Please select a status
                                        </mat-error>
                                    </mat-form-field>
                                </div>
                            </div>
                            <div class="col-12">
                                <div class="form-group">
                                    <label class="app-field-label">
                                        Resolution Notes
                                        <span class="app-field-required" *ngIf="statusForm.get('Status')?.value === TicketStatus.Resolved">*</span>
                                    </label>
                                    <mat-form-field class="w-100">
                                        <textarea matInput formControlName="ResolutionNotes" rows="3"></textarea>
                                        <mat-error *ngIf="statusForm.get('ResolutionNotes')?.errors?.['required']">
                                            Resolution notes are required to mark this ticket as Resolved
                                        </mat-error>
                                    </mat-form-field>
                                </div>
                            </div>
                        </div>
                    </mat-dialog-content>
                </div>
                <mat-dialog-actions align="end">
                    <button mat-raised-button type="button" class="btn btn-secondary" style="margin-right: 10px;"
                        [disabled]="actionSaving" (click)="closeDialog()">Cancel</button>
                    <button mat-raised-button type="submit" class="btn btn-primary" [disabled]="actionSaving">
                        <span *ngIf="actionSaving" class="spinner-border spinner-border-sm me-1"></span>
                        {{ actionSaving ? 'Saving…' : 'Save' }}
                    </button>
                </mat-dialog-actions>
            </form>
        </div>
    </div>
</ng-template>

<ng-template #resolveTicketDialog>
    <div class="modal-dialog">
        <div class="modal-content">
            <div class="modal-header">
                <h4 class="popup-title">Resolve Ticket {{ selectedTicket?.TicketNumber }}</h4>
                <button type="button" class="btn-close" aria-label="Close" (click)="closeDialog()"></button>
            </div>
            <form class="diagSave" [formGroup]="resolveForm" (ngSubmit)="submitResolve()" autocomplete="off">
                <div class="modal-body">
                    <mat-dialog-content>
                        <div *ngIf="actionError" class="ticket-action-error" role="alert">{{ actionError }}</div>
                        <div class="form-group">
                            <label class="app-field-label">Resolution Notes<span class="app-field-required">*</span></label>
                            <mat-form-field class="w-100">
                                <textarea matInput formControlName="ResolutionNotes" rows="4" required></textarea>
                                <mat-error *ngIf="resolveForm.get('ResolutionNotes')?.errors?.['required']">
                                    Resolution notes are required to mark this ticket as Resolved
                                </mat-error>
                            </mat-form-field>
                        </div>
                    </mat-dialog-content>
                </div>
                <mat-dialog-actions align="end">
                    <button mat-raised-button type="button" class="btn btn-secondary" style="margin-right: 10px;"
                        [disabled]="actionSaving" (click)="closeDialog()">Cancel</button>
                    <button mat-raised-button type="submit" class="btn btn-primary" [disabled]="actionSaving">
                        <span *ngIf="actionSaving" class="spinner-border spinner-border-sm me-1"></span>
                        {{ actionSaving ? 'Resolving…' : 'Resolve' }}
                    </button>
                </mat-dialog-actions>
            </form>
        </div>
    </div>
</ng-template>

<ng-template #closeTicketDialog>
    <div class="modal-dialog">
        <div class="modal-content">
            <div class="modal-header">
                <h4 class="popup-title">Close Ticket {{ selectedTicket?.TicketNumber }}</h4>
                <button type="button" class="btn-close" aria-label="Close" (click)="closeDialog()"></button>
            </div>
            <form class="diagSave" [formGroup]="closeForm" (ngSubmit)="submitClose()" autocomplete="off">
                <div class="modal-body">
                    <mat-dialog-content>
                        <div *ngIf="actionError" class="ticket-action-error" role="alert">{{ actionError }}</div>
                        <div>Are you sure you want to close this ticket? This is only allowed while it is Resolved.</div>
                        <div class="form-group mt-2">
                            <label class="app-field-label">Closing Note</label>
                            <mat-form-field class="w-100">
                                <textarea matInput formControlName="ClosingNote" rows="3"></textarea>
                            </mat-form-field>
                        </div>
                    </mat-dialog-content>
                </div>
                <mat-dialog-actions align="end">
                    <button mat-raised-button type="button" class="btn btn-secondary" style="margin-right: 10px;"
                        [disabled]="actionSaving" (click)="closeDialog()">Cancel</button>
                    <button mat-raised-button type="submit" class="btn btn-primary" [disabled]="actionSaving">
                        <span *ngIf="actionSaving" class="spinner-border spinner-border-sm me-1"></span>
                        {{ actionSaving ? 'Closing…' : 'Close Ticket' }}
                    </button>
                </mat-dialog-actions>
            </form>
        </div>
    </div>
</ng-template>

<ng-template #reopenTicketDialog>
    <div class="modal-dialog">
        <div class="modal-content">
            <div class="modal-header">
                <h4 class="popup-title">Reopen Ticket {{ selectedTicket?.TicketNumber }}</h4>
                <button type="button" class="btn-close" aria-label="Close" (click)="closeDialog()"></button>
            </div>
            <form class="diagSave" [formGroup]="reopenForm" (ngSubmit)="submitReopen()" autocomplete="off">
                <div class="modal-body">
                    <mat-dialog-content>
                        <div *ngIf="actionError" class="ticket-action-error" role="alert">{{ actionError }}</div>
                        <div>Are you sure you want to reopen this ticket?</div>
                        <div class="form-group mt-2">
                            <label class="app-field-label">Reason</label>
                            <mat-form-field class="w-100">
                                <textarea matInput formControlName="Reason" rows="3"></textarea>
                            </mat-form-field>
                        </div>
                    </mat-dialog-content>
                </div>
                <mat-dialog-actions align="end">
                    <button mat-raised-button type="button" class="btn btn-secondary" style="margin-right: 10px;"
                        [disabled]="actionSaving" (click)="closeDialog()">Cancel</button>
                    <button mat-raised-button type="submit" class="btn btn-primary" [disabled]="actionSaving">
                        <span *ngIf="actionSaving" class="spinner-border spinner-border-sm me-1"></span>
                        {{ actionSaving ? 'Reopening…' : 'Reopen' }}
                    </button>
                </mat-dialog-actions>
            </form>
        </div>
    </div>
</ng-template>

<!-- Add Ticket: an admin raising a ticket on a clinic's behalf (work item 27050) -->
<ng-template #addTicketDialog>
    <div class="modal-dialog">
        <div class="modal-content">
            <div class="modal-header">
                <h4 class="popup-title">Add Ticket</h4>
                <button type="button" class="btn-close" aria-label="Close" [disabled]="actionSaving" (click)="closeDialog()"></button>
            </div>
            <form class="diagSave" [formGroup]="addTicketForm" (ngSubmit)="submitAddTicket()" autocomplete="off">
                <div class="modal-body">
                    <mat-dialog-content>
                        <div *ngIf="actionError" class="ticket-action-error" role="alert">{{ actionError }}</div>
                        <div class="row">
                            <div class="col-12">
                                <div class="form-group">
                                    <label class="app-field-label" for="addTicketClinic">Clinic<span class="app-field-required">*</span></label>
                                    <mat-form-field class="w-100">
                                        <input id="addTicketClinic" type="text" matInput formControlName="Clinic"
                                            placeholder="Search by clinic, doctor, email or domain"
                                            [matAutocomplete]="clinicAutocomplete" (input)="onClinicSearch($any($event.target).value)" />
                                        <mat-autocomplete #clinicAutocomplete="matAutocomplete" [displayWith]="clinicLabel">
                                            <mat-option *ngFor="let clinic of filteredClinicOptions" [value]="clinic" class="clinic-option">
                                                <span class="clinic-option-name">{{ clinicLabel(clinic) }}</span>
                                                <span class="clinic-option-meta">{{ clinic.DoctorName }}<ng-container *ngIf="clinic.DoctorName && clinic.Domain"> · </ng-container>{{ clinic.Domain }}</span>
                                            </mat-option>
                                        </mat-autocomplete>
                                        <mat-error *ngIf="addTicketForm.get('Clinic')?.errors?.['clinicRequired']">
                                            Please pick a clinic from the list
                                        </mat-error>
                                    </mat-form-field>
                                </div>
                            </div>
                            <div class="col-12 col-md-8">
                                <div class="form-group">
                                    <label class="app-field-label" for="addTicketSubject">Subject<span class="app-field-required">*</span></label>
                                    <mat-form-field class="w-100">
                                        <input id="addTicketSubject" type="text" matInput formControlName="Subject"
                                            [maxlength]="maxTicketSubjectLength" placeholder="Short summary of the issue" />
                                        <mat-error *ngIf="addTicketForm.get('Subject')?.errors?.['required'] || addTicketForm.get('Subject')?.errors?.['whitespace']">
                                            Subject is required
                                        </mat-error>
                                        <mat-error *ngIf="addTicketForm.get('Subject')?.errors?.['maxlength']">
                                            Subject can be at most {{ maxTicketSubjectLength }} characters
                                        </mat-error>
                                    </mat-form-field>
                                </div>
                            </div>
                            <div class="col-12 col-md-4">
                                <div class="form-group">
                                    <label class="app-field-label">Priority<span class="app-field-required">*</span></label>
                                    <mat-form-field class="w-100">
                                        <mat-select formControlName="Priority" [panelClass]="'custom-select-panel'" [disableOptionCentering]="true">
                                            <mat-option *ngFor="let option of priorityFilterOptions" [value]="option.Id">{{ option.Name }}</mat-option>
                                        </mat-select>
                                    </mat-form-field>
                                </div>
                            </div>
                            <div class="col-12">
                                <div class="form-group">
                                    <label class="app-field-label" for="addTicketDescription">Description<span class="app-field-required">*</span></label>
                                    <mat-form-field class="w-100">
                                        <textarea id="addTicketDescription" matInput formControlName="Description" rows="5"
                                            placeholder="Describe the issue, steps to reproduce, and anything already tried"></textarea>
                                        <mat-error *ngIf="addTicketForm.get('Description')?.invalid">
                                            Description is required
                                        </mat-error>
                                    </mat-form-field>
                                </div>
                            </div>
                            <div class="col-12">
                                <div class="form-group">
                                    <span class="app-field-label">
                                        Attachments <span class="ticket-attach-hint">(optional - up to {{ maxTicketAttachments }} images)</span>
                                    </span>
                                    <div class="ticket-attachments">
                                        <label class="btn btn-secondary btn-sm ticket-attach-btn"
                                            [class.disabled]="actionSaving || ticketAttachments.length >= maxTicketAttachments">
                                            Choose images
                                            <input type="file" accept="image/*" multiple hidden
                                                [disabled]="actionSaving || ticketAttachments.length >= maxTicketAttachments"
                                                (change)="onAttachmentsPicked($event)" />
                                        </label>
                                        <ul class="ticket-attachment-list" *ngIf="ticketAttachments.length">
                                            <li *ngFor="let file of ticketAttachments; let i = index">
                                                <span class="ticket-attachment-name" [title]="file.name">{{ file.name }}</span>
                                                <button type="button" class="ticket-attachment-remove" [disabled]="actionSaving"
                                                    [attr.aria-label]="'Remove ' + file.name" (click)="removeAttachment(i)">
                                                    <kendo-svg-icon [icon]="icons.remove" size="small"></kendo-svg-icon>
                                                </button>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </mat-dialog-content>
                </div>
                <mat-dialog-actions align="end">
                    <button mat-raised-button type="button" class="btn btn-secondary" style="margin-right: 10px;"
                        [disabled]="actionSaving" (click)="closeDialog()">Cancel</button>
                    <button mat-raised-button type="submit" class="btn btn-primary" [disabled]="actionSaving">
                        <span *ngIf="actionSaving" class="spinner-border spinner-border-sm me-1"></span>
                        {{ actionSaving ? 'Adding…' : 'Add Ticket' }}
                    </button>
                </mat-dialog-actions>
            </form>
        </div>
    </div>
</ng-template>
